import React, { useEffect, useState } from "react";
import {
  OverlayTrigger,
  Tooltip,
  Button,
  Form,
  Col,
  Row,
  Modal,
} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import cellEditFactory from "react-bootstrap-table2-editor";
import SVG from "react-inlinesvg";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../_metronic/_partials/controls";
import {
  sortCaret,
  headerSortingClasses,
} from "../../../../../_metronic/_helpers";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  formatDate,
  showSuccessDialog,
  showErrorDialog,
  StatusFormatter,
  useForceUpdate,
  sizePerPageList,
  showDialog,
  showConfirmDialog,
  formatCurrency,
} from "../../../../utility";
import { LayoutSplashScreen } from "../../../../../_metronic/layout";

import DeleteIcon from "@material-ui/icons/Delete";
import ImageIcon from "@material-ui/icons/Image";
import Select from "react-select";
import moment from "moment";
import InputNumber from "../../../../utility/InputNumber";
import {
  selectSelected,
  uploadFile,
  createApproval,
  resetData,
  selectReasonParam,
  fetchReasonParam,
  editDraft,
  selectLoading,
  fetchBatch,
  selectDataBatch,
} from "./withoutRtvSlice";
import {
  fetchCustomer,
  selectDataCustomer,
  selectPageNo,
  selectPageSize,
} from "../../with-rtv/withrtvSlice";
import LoadingFetchData from "../../../../utility/LoadingFetchData";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";

export const WithoutRtvDetail = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const forceUpdate = useForceUpdate();
  const reasonParam = useSelector(selectReasonParam);
  const data = useSelector(selectSelected);
  const loading = useSelector(selectLoading);
  const dataCustomer = useSelector(selectDataCustomer);
  const dataBatch = useSelector(selectDataBatch);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);

  const { id } = useParams();

  // Add status field to prevent object is not extensible error
  const getValueDefaultUom = (value, options) => {
    return options.filter((val) => value === val.uom);
  };

  const initData = data.map((item, index) => ({
    ...item,
    no: index + 1,
    returnUom: item.uom,
    customerCodeOld: item.customerCode,
    customerNameOld: item.customerName,
    plantCodeOld: item.plantCode,
    defaulfUom: getValueDefaultUom(item.uom, item.altUom),
    lineOld: item.line,
  }));

  const [tableData, setTableData] = useState(initData);
  const [reason, setReason] = useState("");
  const [remark, setRemark] = useState("");
  const [rowIndexTable, setRowIndexTable] = useState(null);

  const [returnPoNumber, setReturnPoNumber] = useState(null);
  const [disabledButton, setDisabledDraftButton] = useState(false);
  const [requestDate, setRequestDate] = useState("");
  const [materialRemarks, setMaterialRemarks] = useState("");
  const [pelapor, setPelapor] = useState("");

  const [btnDisabled, setBtnDisabled] = useState(false);

  console.log(tableData, "tableData");

  let dateDefault =
    new Date().getFullYear() +
    "-" +
    (new Date().getMonth() + 1) +
    "-" +
    new Date().getDate();

  const postDateDefault = moment(dateDefault).format("YYYY-MM-DD");

  useEffect(() => {
    setRequestDate(postDateDefault);
  }, []);

  useEffect(() => {
    // Reset on first load
    dispatch(resetData());

    // Fetch data on first load
    dispatch(
      fetchReasonParam({
        paramGroupId: "REASON",
        pageNo: 1,
        pageSize: 20,
      })
    );
  }, [dispatch]);

  useEffect(() => {
    tableData.forEach((item) => {
      item.tempAvailableQty = item.availableQty;
      item.qty = item.availableQty;
    });
    setTableData(tableData);
  }, [tableData]);

  const optionsTablePage = {
    showTotal: true,
    totalSize: tableData.length,
    sizePerPageList: sizePerPageList,
  };

  // Return if data null
  if (!tableData.length > 0) {
    history.push("/new-return/non-rtv");
  }

  const handleReasonChange = (value) => {
    setReason(value.value);
    forceUpdate();
  };

  const reasonOptions = reasonParam.map((e) => {
    return {
      value: e.paramCode,
      label: e.paramValue,
    };
  });

  const getValueReason = (value, options) => {
    const return_value = options.filter((val) => value === val.value);
    return return_value;
  };

  // UOM Render
  const getValueUom = (value, options) => {
    return options.filter((val) => value === val.label);
  };

  const handleUomValueChange = async (
    e,
    row,
    rowIndex,
    options,
    formatExtraData
  ) => {
    const selected = options.filter((val) => e.value === val.label);
    const uom = selected[0];
    const baseUom = formatExtraData[rowIndex].defaulfUom[0].uom;
    const fromNumerator = formatExtraData[rowIndex].defaulfUom[0].numerator;
    const fromDenumerator = formatExtraData[rowIndex].defaulfUom[0].denumerator;
    const selectedUom = uom.value;
    const toNumerator = uom.numerator;
    const toDenumerator = uom.denumerator;

    formatExtraData[rowIndex].returnUom = e.value;

    if (selectedUom === baseUom) {
      formatExtraData[rowIndex].qty = formatExtraData[rowIndex].availableQty;
      formatExtraData[rowIndex].tempAvailableQty =
        formatExtraData[rowIndex].availableQty;
    } else if (fromNumerator >= fromDenumerator) {
      if (fromNumerator < toNumerator) {
        console.log("xx");
        formatExtraData[rowIndex].tempAvailableQty =
          formatExtraData[rowIndex].availableQty *
          (((fromNumerator * fromDenumerator) / toNumerator) * toDenumerator);
        formatExtraData[rowIndex].qty =
          formatExtraData[rowIndex].availableQty *
          (((fromNumerator * fromDenumerator) / toNumerator) * toDenumerator);
      } else {
        console.log("yy");
        formatExtraData[rowIndex].tempAvailableQty =
          formatExtraData[rowIndex].availableQty *
          (fromNumerator * fromDenumerator * toNumerator * toDenumerator);
        formatExtraData[rowIndex].qty =
          formatExtraData[rowIndex].availableQty *
          (fromNumerator * fromDenumerator * toNumerator * toDenumerator);
      }
    } else {
      if (fromNumerator < toNumerator) {
        console.log("zz");
        formatExtraData[rowIndex].tempAvailableQty =
          formatExtraData[rowIndex].availableQty *
          ((fromNumerator / fromDenumerator / toNumerator) * toDenumerator);
        formatExtraData[rowIndex].qty =
          formatExtraData[rowIndex].availableQty *
          ((fromNumerator / fromDenumerator / toNumerator) * toDenumerator);
      } else {
        console.log("ss");
        formatExtraData[rowIndex].tempAvailableQty =
          formatExtraData[rowIndex].availableQty *
          ((fromNumerator / fromDenumerator) * toNumerator * toDenumerator);
        formatExtraData[rowIndex].qty =
          formatExtraData[rowIndex].availableQty *
          ((fromNumerator / fromDenumerator) * toNumerator * toDenumerator);
      }
    }
    setTableData(formatExtraData);
    forceUpdate();
  };

  const renderUom = (cell, row, rowIndex, formatExtraData) => {
    const alt_uom = row.altUom;
    let cell_uom = cell;

    const options_this = [
      { value: "", label: "", numerator: "", denumerator: "" },
    ];

    alt_uom.map((value, index) => {
      options_this.push({
        value: value.uom,
        label: value.uom,
        numerator: value.numerator,
        denumerator: value.denumerator,
      });
    });

    return (
      <Select
        isSearchable={false}
        className="uom-select"
        menuPortalTarget={document.body}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        key={`uom-${rowIndex}`}
        options={options_this}
        onChange={(e) =>
          handleUomValueChange(e, row, rowIndex, options_this, formatExtraData)
        }
        value={getValueUom(cell_uom, options_this)}
      />
    );
  };

  const uploadFormatter = (cell, row, rowIndex, formatExtraData) => {
    let render = (
      <div>
        <input
          type="file"
          onChange={(e) =>
            handleUpload(e, rowIndex, row, cell, formatExtraData)
          }
          style={{ color: "transparent", width: "91px" }}
          accept="image/png, image/jpeg, image/jpg"
        />
      </div>
    );

    if (row.attachmentId) {
      render = (
        <div className="filename-container">
          <div className="div-filename">{row.filename}</div>
          <a
            href={`${process.env.REACT_APP_API_URL}/return/attachment/${row.attachmentId}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <ImageIcon style={{ color: "#648DAE", marginRight: "5px" }} />
          </a>
          <DeleteIcon
            onClick={(e) => handleDeleteFile(e, rowIndex, formatExtraData)}
          />
        </div>
      );
    }

    // if (formatExtraData.reason === "132") {
    //   render = "Cannot Upload";
    // }

    return render;
  };

  const handleUpload = async (e, rowIndex, row, cell, formatExtraData) => {
    const file = e.target.files[0];
    const params = {
      file: file,
    };
    try {
      const response = await dispatch(uploadFile(params));
      if (response.payload.status === 200) {
        // const action = await showSuccessDialog(response.payload.data);

        const temp = tableData;
        temp[rowIndex].attachmentId = response.payload.data;
        temp[rowIndex].filename = file.name;
        setTableData(temp);
        forceUpdate();
      }
    } catch (error) {
      console.log(error);
      showErrorDialog("Something went wrong!");
    }
  };

  const handleDeleteFile = async (e, rowIndex) => {
    const temp = tableData;
    temp[rowIndex].attachmentId = null;
    temp[rowIndex].filename = null;
    forceUpdate();
  };

  const handleQty = (e, row, rowIndex, formatExtraData) => {
    if (parseFloat(row.qty) > parseFloat(row.availableQty)) {
      row.qty = row.availableQty;
      forceUpdate();
      return;
    } else if (row.qty < 0) {
      row.qty = 0;
      forceUpdate();
      return;
    }
  };

  const inputQtyFormmater = (e, row, rowIndex, formatExtraData) => {
    return (
      <input
        type="number"
        className="input-qty-return"
        step="any"
        value={parseFloat(row.qty)}
        onBlur={handleQty(e, row, rowIndex, formatExtraData)}
      />
    );
  };

  // function Remark
  const handleRemarkRowChange = (e, row, rowIndex, formatExtraData) => {
    formatExtraData[rowIndex].remarkRow = e.target.value;
    setTableData(formatExtraData);
  };

  const remarkFormatter = (cell, row, rowIndex, formatExtraData) => {
    return (
      <div>
        <Form.Control
          className={`remark-brqa`}
          as="textarea"
          placeholder="Leave a comment here"
          style={{ height: "80px" }}
          onChange={(e) =>
            handleRemarkRowChange(e, row, rowIndex, formatExtraData)
          }
          maxLength={255}
        />
      </div>
    );
  };

  const validateIsChanges = () => {
    let isValid = true;

    for (let e of tableData) {
      // Check if 'plant' and 'plantCode' properties exist before accessing their values
      const isPlantValid = e.plant && e.plant.startsWith("19");
      const isPlantCodeValid = e.plantCode && e.plantCode.startsWith("19");


      if (!isPlantValid || !isPlantCodeValid) {
        break;
      }

      if (e.plant !== e.plantCode) {
        isValid = false;
        break;
      }
    }

    return isValid;
  };
  const handleDraft = () => {
    //checking attachment
    let isChanges = "N";

    if (!validateIsChanges()) {
      isChanges = "Y";
    }

    // Setup Request Body Params
    tableData.map((value) => {
      if (reason === "132") {
        value.sloc = "B41";
      } else if (reason === "135") {
        value.sloc = "B42";
      }
      if (value.qty) {
      } else {
        value.qty = value.availableQty;
      }
      if (value.returnUom) {
      } else {
        value.returnUom = value.uom;
      }
    });

    const id = tableData[0].returnId;

    const params = {
      invoiceNo: tableData[0].invoiceNo,
      taxInvoiceNo: tableData[0].taxInvoiceNo,
      transactionDate: tableData[0].transactionDate,
      customerCode: tableData[0].customerCode,
      plantCode: tableData[0].plantCode,
      distributionChannel: tableData[0].distributionChannel,
      po: returnPoNumber,
      transactionDate: moment(tableData[0].transactionDate).format(
        "YYYY-MM-DD"
      ),
      reasonCode: reason,
      returnType: "NONMTKA",
      remark: remark,
      dataSource: tableData[0].dataSource,
      draft: true,
      returnId: tableData[0].returnId,
      customerPODate: requestDate,
      reporter: pelapor,
      items: tableData,
      isChanges: isChanges,
      plant: tableData[0].plant,
    };

    console.log(params, "json");
    console.log(id, "id");

    setBtnDisabled(true);

    // callApi(params);
    if (id === undefined) {
      callApi(params);
    } else {
      callApiUpdate({ params, id });
    }
  };

  const handleSave = () => {
    //checking attachment
    let isChanges = "N";

    if (!validateIsChanges()) {
      isChanges = "Y";
    }

    const attachmentChecker = [];
    tableData.map((val, index) => {
      if (val.attachmentId) {
      } else {
        attachmentChecker.push(index);
      }
    });
    if (reason === "") {
      setBtnDisabled(false);
      return showErrorDialog("Please Select Reason !");
    }

    if (reason !== "132" && attachmentChecker.length > 0) {
      setBtnDisabled(false);
      return showErrorDialog("Please Upload Image !");
    }

    if (remark === "") {
      setBtnDisabled(false);
      return showErrorDialog("Please fill in the remarks !");
    }

    // Setup Request Body Params
    tableData.map((value) => {
      if (reason === "132") {
        value.sloc = "B41";
      } else if (reason === "135") {
        value.sloc = "B42";
      }
      if (value.qty) {
      } else {
        value.qty = value.availableQty;
      }
      if (value.returnUom) {
      } else {
        value.returnUom = value.uom;
      }
    });

    // const items = tableData.map((e) => {
    //   return {
    //     // update
    //     attachmentId: e.attachmentId,
    //     batch: e.batch,
    //     clientCode: e.clientCode,
    //     clientName: e.clientName,
    //     crprgp: e.crprgp,
    //     expiredDate: e.expiredDate,
    //     materialCode: e.materialCode,
    //     materialName: e.materialName,
    //     materialRemarks: e.materialRemarks,
    //     netPrice: e.netPrice,
    //     nra: e.nra,
    //     availableQty: e.availableQty,
    //     qty: e.qty,
    //     returnUom: e.returnUom,
    //     sloc: e.sloc,
    //     uom: e.uom,
    //     remark: e.remarkRow,
    //     rayonType: e.rayonType,
    //     line: e.line,
    //     returnDetailId: e.returnDetailId,
    //     division: e.division,
    //   };
    // });

    const id = tableData[0].returnId;

    const params = {
      invoiceNo: tableData[0].invoiceNo,
      taxInvoiceNo: tableData[0].taxInvoiceNo,
      customerCode: tableData[0].customerCode,
      plantCode: tableData[0].plantCode,
      distributionChannel: tableData[0].distributionChannel,
      po: returnPoNumber,
      transactionDate: moment(tableData[0].transactionDate).format(
        "YYYY-MM-DD"
      ),
      reasonCode: reason,
      crprgp: tableData[0].crprgp,
      returnType: "NONMTKA",
      remark: remark,
      draft: false,
      dataSource: tableData[0].dataSource,
      rayonType: tableData[0].rayonType,
      customerPODate: requestDate,
      reporter: pelapor,
      items: tableData,
      returnId: tableData[0].returnId,
      // isChanges:
      //   id === undefined || id === null || id === ""
      //     ? isChanges
      //     : tableData[0].isChanges,

      isChanges: isChanges,
      plant: tableData[0].plant,
    };
    setBtnDisabled(true);

    if (id === undefined) {
      callApi(params);
    } else {
      callApiUpdate({ params, id });
    }
  };

  const callApi = async (params) => {
    try {
      const response = await dispatch(createApproval(params));
      if (response.payload.status === 200) {
        console.log(response, "response");
        const action = await showSuccessDialog(
          "Data has been saved!",
          `Return have been Saved, your return number : <strong>${response.payload.data.data.retNumber}</strong>`
        );
        if (action.isConfirmed) history.push("/new-return/non-rtv");
        setBtnDisabled(false);
      } else {
        showErrorDialog(response.payload.data.message);
        setBtnDisabled(false);
      }
    } catch (error) {
      console.log("error", error);
      setBtnDisabled(false);
      showErrorDialog(error.message);
    }
  };

  const callApiUpdate = async ({ params, id }) => {
    try {
      const response = await dispatch(editDraft({ params, id }));
      if (response.payload.status === 200) {
        console.log(response, "response");
        const action = await showSuccessDialog(
          "Data has been saved!",
          `Return have been Saved, your return number : <strong>${response.payload.data.data.retNumber}</strong>`
        );
        if (action.isConfirmed) history.push("/new-return/non-rtv");
        setBtnDisabled(false);
      } else {
        showErrorDialog(response.payload.data.message);
        setBtnDisabled(false);
      }
    } catch (error) {
      setBtnDisabled(false);
      showErrorDialog(error.message);
    }
  };

  const StatusCrpFormatter = (cellContent, row) => {
    let label = "";
    if (cellContent === "Y") {
      label = "Within CRP";
    } else if (cellContent === "N") {
      label = "Non CRP";
    } else if (cellContent === "N/A") {
      label = "N/A";
    }

    return <span>{label}</span>;
  };

  const columns = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "Invoice Ref Num",
      dataField: "invoiceNo",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
      style: { minWidth: "120px" },
    },
    {
      text: "invoice item number",
      dataField: "line",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "100px" },
    },
    {
      text: "Invoice Ref Date",
      dataField: "transactionDate",
      sort: true,
      formatter: formatDate,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "Tax Invoice Ref Num",
      dataField: "taxInvoiceNo",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "PO Ref",
      dataField: "taxInvoiceNo",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "Material",
      dataField: "materialCode",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "Material Desc",
      dataField: "materialName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },

    {
      text: "Client Name",
      dataField: "clientName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "Batch",
      dataField: "batch",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    // {
    //   dataField: "EditBatch",
    //   text: "Edit Batch",
    //   editable: false,
    //   formatExtraData: tableData,
    //   formatter: (e, row, rowIndex, formatExtraData) => (
    //     <div>
    //       <OverlayTrigger
    //         overlay={<Tooltip id="products-edit-tooltip">Edit Batch</Tooltip>}
    //       >
    //         <div
    //           className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
    //           onClick={() => handleShowBatch(e, row, rowIndex, formatExtraData)}
    //         >
    //           <span className="svg-icon svg-icon-md svg-icon-primary">
    //             <SVG
    //               src={toAbsoluteUrl(
    //                 "/media/svg/icons/Communication/Write.svg"
    //               )}
    //             />
    //           </span>
    //         </div>
    //       </OverlayTrigger>
    //     </div>
    //   ),
    // },
    {
      text: "Exp Date",
      dataField: "expiredDate",
      sort: true,
      formatter: formatDate,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "Net Price",
      dataField: "netPrice",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: formatCurrency,
    },
    {
      text: "Fullbox Client",
      dataField: "nonFraction",
      formatter: StatusFormatter,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "UOM",
      dataField: "returnUom",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: renderUom,
      formatExtraData: tableData,
      editable: false,
    },
    {
      text: "Avail Qty",
      dataField: "tempAvailableQty",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },

    {
      text: "Return Qty",
      dataField: "qty",
      // editable: false,
      formatExtraData: tableData,
      formatter: inputQtyFormmater,
      editorRenderer: (editorProps, value) => {
        return <InputNumber {...editorProps} value={value} />;
      },
    },
    {
      text: "CRP/RGP",
      dataField: "crprgp",
      formatter: StatusCrpFormatter,
      align: "center",
      editable: false,
    },
    {
      text: "Photo Product",
      dataField: "attachmentId",
      // hidden: reason === "132" ? true : false,
      formatter: (cell, row, rowIndex, formatExtraData) =>
        uploadFormatter(cell, row, rowIndex, formatExtraData),
      formatExtraData: {
        reason: reason,
        tableData: tableData,
      },
      editable: false,
    },
    {
      text: "Remarks",
      dataField: "remarkRow",
      formatter: remarkFormatter,
      formatExtraData: tableData,
      editable: false,
    },
  ];

  // Modal Customer
  const [show, setShow] = useState(false);
  const [customerCode, setCustomerCode] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [customerOld, setCustomerOld] = useState({
    customerCode: "",
    customerName: "",
  });
  const [overlayCustomer, setOverlayCustomer] = useState(false);

  const handleClose = () => {
    setCustomerCode("");
    setCustomerName("");
    setShow(false);
    setTableDataCustomer([]);
    setShow(false);
  };
  const handleShow = () => setShow(true);

  const [tableDataCustomer, setTableDataCustomer] = useState(dataCustomer);

  useEffect(() => {
    // Add number
    const pageBefore = pageSize * (pageNo - 1);
    const initData = dataCustomer.map((item, index) => {
      return {
        ...item,
        no: index + 1 + pageBefore,
      };
    });
    setTableDataCustomer(initData);
  }, [dataCustomer, pageSize, pageNo]);

  const handleSearchCustomer = async () => {
    setOverlayCustomer(true);
    const params = {
      customerCode: customerCode,
      customerName: customerName,
      npwp: tableData[0].npwp,
      pageNo: 1,
      pageSize: 100,
    };
    await dispatch(fetchCustomer(params));
    setOverlayCustomer(false);
  };

  const rowEventsCustomer = {
    onClick: (e, row, rowIndex, cell) => {
      if (row.customerBlocked === true) {
        showDialog(row.blockRemark);
      } else {
        const action = showConfirmDialog(
          `Do you want change customer ${tableData[0].customerCodeOld} "${tableData[0].customerNameOld}", Plant "${tableData[0].plantCodeOld}" To Customer ${row.customerCode} "${row.customerName} Plant ${row.plantCode}"`
        ).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            setCustomerCode("");
            setCustomerName("");
            setShow(false);
            setTableDataCustomer([]);
            setShow(false);
            const initData = tableData.map((item, index) => ({
              ...item,
              customerCode: row.customerCode.toString(),
              customerName: row.customerName.toString(),
              plantCode: row.plantCode,
            }));
            setTableData(initData);
          }
        });
      }
    },
  };

  const columnsCustomer = [
    { text: "No", dataField: "no" },
    { text: "Customer Code", dataField: "customerCode" },
    { text: "Customer Name", dataField: "customerName" },
    { text: "distribution Channel", dataField: "distChannel" },
    // { text: "Address", dataField: "street1" },
    { text: "City", dataField: "city" },
    { text: "Sales Office", dataField: "salesOffice" },
    { text: "Plant Code", dataField: "plantCode" },
    { text: "Plant Name", dataField: "plantName" },
  ];

  // Modal Batch
  const [showBatch, setShowBatch] = useState(false);
  const [materialCode, setMaterialCode] = useState("");
  const [batch, setBatch] = useState("");
  const [selectMaterial, setSelectMaterial] = useState([]);
  const [overlayBatch, setOverlayBatch] = useState(false);
  const [indexBatch, setIndexBatch] = useState("");

  const handleCloseBatch = () => {
    setMaterialCode("");
    setBatch("");
    setShowBatch(false);
    setTableDataCustomer([]);
    setOverlayBatch(false);
  };
  const handleShowBatch = (e, row, rowIndex, formatExtraData) => {
    setIndexBatch(rowIndex);
    setShowBatch(true);
  };

  const [tableDataBatch, setTableDataBatch] = useState(dataBatch);

  useEffect(() => {
    // Add number
    const pageBefore = pageSize * (pageNo - 1);
    const initData = dataBatch.map((item, index) => {
      return {
        ...item,
        no: index + 1 + pageBefore,
      };
    });
    setTableDataBatch(initData);
  }, [dataBatch, pageSize, pageNo]);

  const handleSearchBatch = async () => {
    setOverlayBatch(true);
    const params = {
      itemCode: materialCode,
      batch: batch,
      // plant: defaultPlant.toString(),
      pageNo: 1,
      pageSize: 100,
    };
    await dispatch(fetchBatch(params));
    setOverlayBatch(false);
  };

  const rowEventsBatch = {
    onClick: (e, row, rowIndex) => {
      const temp = [...tableData];
      const indexTemp = { ...temp[indexBatch] };

      indexTemp.batch = row.batch;
      temp[indexBatch] = indexTemp;

      setTableData(temp);
      setMaterialCode("");
      setBatch("");
      setTableDataBatch([]);
      setShowBatch(false);
    },
  };

  const columnsBatch = [
    { text: "No", dataField: "no" },
    { text: "Material Code", dataField: "itemCode" },
    { text: "batch", dataField: "batch" },
  ];

  return tableData.length > 0 ? (
    loading ? (
      <LayoutSplashScreen />
    ) : (
      <>
        <Card>
          <CardHeader title="Without RTV Detail">
            {/* <CardHeaderToolbar>
              <Button variant="primary" className="mr-5" onClick={handleShow}>
                Change Customer
              </Button>
            </CardHeaderToolbar> */}
          </CardHeader>
          <CardBody>
            <Form>
              <Form.Group as={Row}>
                <Col sm={6}>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Invoice Ref Number</b>
                    </Form.Label>
                    <Col sm={7}>
                      <Form.Control
                        type="text"
                        disabled
                        value={tableData[0].invoiceNo}
                      />
                    </Col>
                  </Form.Group>
                  {tableData[0].customerCodeOld !==
                    tableData[0].customerCode && (
                    <>
                      <Form.Group as={Row}>
                        <Form.Label column sm={4}>
                          <b>Customer Code Old</b>
                        </Form.Label>
                        <Col sm={7}>
                          <Form.Control
                            type="text"
                            placeholder="Customer Code"
                            disabled
                            value={tableData[0].customerCodeOld}
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row}>
                        <Form.Label column sm={4}>
                          <b>Customer Name Old</b>
                        </Form.Label>
                        <Col sm={7}>
                          <Form.Control
                            type="text"
                            placeholder="Customer Name"
                            disabled
                            value={tableData[0].customerNameOld}
                          />
                        </Col>
                      </Form.Group>
                    </>
                  )}
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Customer Code</b>
                    </Form.Label>
                    <Col sm={7}>
                      <Form.Control
                        type="text"
                        placeholder="Customer Code"
                        disabled
                        value={tableData[0].customerCode}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Customer Name</b>
                    </Form.Label>
                    <Col sm={7}>
                      <Form.Control
                        type="text"
                        placeholder="Customer Name"
                        disabled
                        value={tableData[0].customerName}
                      />
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} controlId="pelapor">
                    <Form.Label column sm={4}>
                      <b>Reporter</b>
                    </Form.Label>
                    <Col sm={7}>
                      <Form.Control
                        type="text"
                        placeholder="Pelapor"
                        onChange={(e) => setPelapor(e.target.value)}
                        value={pelapor}
                      />
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Remarks</b>
                    </Form.Label>
                    <Col sm={7}>
                      <Form.Control
                        as="textarea"
                        onChange={(e) => {
                          setRemark(e.target.value);
                        }}
                        value={remark}
                        placeholder="Leave a comment here"
                        maxLength={100}
                        style={{ height: "100px" }}
                      />
                    </Col>
                  </Form.Group>
                </Col>
                {/* Row kiri */}
                <Col sm={6}>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Tax Invoice Number</b>
                    </Form.Label>
                    <Col sm={7}>
                      <Form.Control
                        type="text"
                        disabled
                        value={tableData[0].taxInvoiceNo}
                      />
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Plant Name</b>
                    </Form.Label>
                    <Col sm={7}>
                      <Form.Control
                        type="text"
                        disabled
                        value={tableData[0].plantName}
                      />
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Reason</b>
                    </Form.Label>
                    <Col sm={7}>
                      <Select
                        options={reasonOptions}
                        value={getValueReason(reason, reasonOptions)}
                        placeholder="Select Reason..."
                        onChange={handleReasonChange}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Customer Request Date</b>
                    </Form.Label>
                    <Col sm={7}>
                      <Form.Control
                        type="date"
                        onChange={(e) => {
                          setRequestDate(e.target.value);
                        }}
                        value={requestDate}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Return PO Number</b>
                    </Form.Label>
                    <Col sm={7}>
                      <Form.Control
                        as="textarea"
                        onChange={(e) => setReturnPoNumber(e.target.value)}
                        placeholder="Leave a comment here"
                        maxLength={35}
                        style={{ height: "80px" }}
                        value={returnPoNumber}
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Form.Group>

              {/* Table Material*/}
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                keyField="uuid"
                data={tableData}
                columns={columns}
                pagination={paginationFactory(optionsTablePage)}
                hover
                cellEdit={cellEditFactory({
                  mode: "click",
                  blurToSave: true,
                })}
              />
            </Form>

            <Form>
              <Row>
                <Col md="6" sm="6" lg="7">
                  <Button
                    variant="primary"
                    className="mr-5"
                    disabled={btnDisabled}
                    onClick={handleDraft}
                  >
                    Draft
                  </Button>
                  <Button
                    variant="success"
                    className="mr-5"
                    disabled={btnDisabled}
                    onClick={handleSave}
                  >
                    Save
                  </Button>
                  <Button
                    variant="secondary"
                    className="mr-5"
                    onClick={() => history.push("/new-return/with-rtv")}
                  >
                    Cancel
                  </Button>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>

        {/* customer */}

        <Modal show={show} onHide={handleClose} size="lg">
          <LoadingFetchData active={overlayCustomer} />
          <Modal.Header closeButton>
            <Modal.Title>Customer Search</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group as={Row}>
                <Col sm={6}>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Customer Code</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        onChange={(e) => {
                          setCustomerCode(e.target.value);
                        }}
                        value={customerCode}
                        required
                        type="number"
                        placeholder="Costumer Code"
                      />
                    </Col>
                  </Form.Group>
                </Col>
                {/* Right Row */}
                <Col sm={6}>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Customer Name</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        onChange={(e) => {
                          setCustomerName(e.target.value);
                        }}
                        value={customerName}
                        required
                        type="text"
                        placeholder="Costumer Name"
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Form.Group>

              <Button
                className="mb-5"
                variant="secondary"
                onClick={handleSearchCustomer}
              >
                Search
              </Button>
            </Form>
            {dataCustomer.length > 0 && (
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                keyField="customerId"
                data={tableDataCustomer}
                columns={columnsCustomer}
                pagination={paginationFactory()}
                // onTableChange={handleTableChangeCustomer}
                rowEvents={rowEventsCustomer}
                hover
              />
            )}
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>

        {/* batch */}
        <Modal show={showBatch} onHide={handleCloseBatch} size="lg">
          <LoadingFetchData active={overlayBatch} />
          <Modal.Header closeButton>
            <Modal.Title>Batch Search</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group as={Row}>
                <Col sm={6}>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Material Code</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        onChange={(e) => {
                          setMaterialCode(e.target.value);
                        }}
                        value={materialCode}
                        required
                      />
                    </Col>
                  </Form.Group>
                </Col>
                {/* Right Row */}
                <Col sm={6}>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Batch</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        onChange={(e) => {
                          setBatch(e.target.value);
                        }}
                        value={batch}
                        required
                        type="text"
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Form.Group>

              <Button
                className="mb-5"
                variant="secondary"
                onClick={handleSearchBatch}
              >
                Search
              </Button>
            </Form>
            {dataBatch.length > 0 && (
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                keyField="batchId"
                data={tableDataBatch}
                columns={columnsBatch}
                pagination={paginationFactory()}
                // onTableChange={handleTableChangeCustomer}
                rowEvents={rowEventsBatch}
                hover
              />
            )}
          </Modal.Body>
        </Modal>
      </>
    )
  ) : null;
};
